import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { Label as AdSlotLabel } from "scmp-app/components/advertisement/ad-slots/ad-slot/styles";
import { VideoPrimary } from "scmp-app/components/content/content-item-render/variants/video-primary";
import { VideoListGridCard } from "scmp-app/components/video/video-list/video-list-grid/video-list-grid-card";
import { VideoUpNextWidget } from "scmp-app/components/video/video-up-next-widget";

export const OuterContainer = styled.div``;

export const Container = styled.section`
  display: grid;
  grid:
    "video-player" min-content
    "up-next-videos" min-content
    "ad-container" min-content
    / 100%;

  ${theme.breakpoints.up("tablet")} {
    grid:
      "video-player video-player" min-content
      "up-next-videos ad-container" min-content
      / minmax(0, 1fr) 300px;
    column-gap: 32px;

    padding: 24px;

    border: 1px solid #dfdfdf;
    border-radius: 20px;
  }

  ${theme.breakpoints.up("desktop")} {
    grid:
      "video-player ad-container" min-content
      "up-next-videos up-next-videos" min-content
      / minmax(0, 1fr) 300px;
    column-gap: 40px;

    margin-inline: 32px;
    padding: 40px;
  }
`;

export const StyledVideoPrimary = styled(VideoPrimary)`
  grid-area: video-player;
`;

export const AdContainer = styled.aside`
  grid-area: ad-container;

  padding-block-end: 12px;
  border-block: none;

  background-color: transparent;

  ${AdSlotLabel} {
    color: #717171;
    font-size: 10px;
    text-transform: uppercase;
  }

  ${theme.breakpoints.only("mobile")} {
    margin-block: 32px;
    padding-block-end: 12px;

    ${setFullViewportWidthStyles()}
  }

  ${theme.breakpoints.only("tablet")} {
    margin-block-start: 32px;
  }
`;

export const StyledVideoUpNextWidget = styled(VideoUpNextWidget)`
  grid-area: up-next-videos;

  margin-block-start: 20px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 32px;
  }
`;

export const TopPicksContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 24px;

  margin-block-start: 20px;

  ${theme.breakpoints.up("tablet")} {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  ${theme.breakpoints.up("desktop")} {
    grid-template-columns: repeat(3, 1fr);

    margin-block-start: 32px;
    margin-inline: 32px;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const StyledVideoListGridCard = styled(VideoListGridCard)`
  ${theme.breakpoints.not("desktop")} {
    :nth-child(9) {
      display: none;
    }
  }
`;
